function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C7DEE2",
  d: "M37.442 100.03c-1.024 0-1.853 1.867-1.853 4.168v25.009c0 2.303.83 4.168 1.853 4.168 1.023 0 1.853-1.865 1.853-4.168v-25.009c0-2.299-.83-4.168-1.853-4.168z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#16c5d9",
  d: "M37.578 0C16.824 0 0 14.055 0 41.68c0 27.623 16.824 54.186 37.578 54.186s37.578-26.563 37.578-54.185C75.158 14.055 58.334 0 37.578 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1194A3",
  d: "M37.578 91.694c-7.178 0-12.525 9.614-12.525 12.504 0 2.895 2.26 4.172 4.175 4.172H45.93c1.91 0 4.173-1.277 4.173-4.172 0-2.89-5.347-12.504-12.525-12.504z"
}));

function SvgBlueBalloon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 134,
    ref: svgRef
  }, props), _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBalloon);
export default __webpack_public_path__ + "static/media/blue-balloon.24fc0b17.svg";
export { ForwardRef as ReactComponent };